import { createCollectionReducer, resolveSiblings } from 'ext/lib/collections';
import { TYPE } from './actions';

const reducer = createCollectionReducer(TYPE);

export default resolveSiblings(reducer, TYPE);

export const selectStepChildren = state => state[TYPE];
export const selectStepChild = (state, id) => selectStepChildren(state)[id];
